import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'mgp-footer',
    // imports: [
    //     FontAwesomeModule
    // ],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.scss'],
    imports: [FaIconComponent]
})
export class FooterComponent {
    constructor(private router: Router) {

    }
}